/**
 * The few words the shared primitives show on their own (a busy button, a copy button, the
 * cancel button of a dialog, the rows of a category list, the eye of a password field).
 * Everything else comes from each app's own dictionary.
 */
export const uiWords = {
  loading: 'טוען…',
  copy: 'העתקה',
  copied: 'הועתק',
  copyFailed: 'ההעתקה נכשלה. סמנו את הטקסט והעתיקו אותו ידנית.',
  cancel: 'ביטול',
  loadMore: 'טען עוד',
  categories: 'קטגוריות',
  products: 'מוצרים',
  uncategorized: 'ללא קטגוריה',
  noSubCategory: 'ללא תת-קטגוריה',
  showPassword: 'הצגת הסיסמה',
  hidePassword: 'הסתרת הסיסמה',
} as const;
